import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '../services';

export const authenticatedGuard: CanActivateFn = () => {
  const auth = inject(AuthenticationService);
  const router = inject(Router);

  const { isAuthenticated } = auth.snapshot();

  return isAuthenticated ? true : router.createUrlTree(['/auth']);
};
